import React, { Component } from 'react'
import { influencerPage } from 'src-features/api/streetSnap';
import StreetGallery from '../component/streetGallery';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import LoaderCover from 'src-features/commonUI/loadingCover';
import ActionArrow from 'src-features/commonUI/arrow'
import {similarPeople} from 'src-features/api/homePage'
import './influencer.less'
import Gallery from 'src-commonUI/photoGallery';
import Loader from 'src-commonUI/infiniteLoad/loader';
import InfiniteScroll from 'src-commonUI/infiniteLoad';

class InfluencerPage extends Component {
    state = {
        isLoading: true,
        hasError: false,
        data: {},
        list: [],
        pageNum: 0,
        pageSize: 20,
    }
    fetchData = async() => {
        if (this.state.data.is_page_end) return

        this.setState({
            isLoading: true,
            hasError: false,
        })
        let data = await influencerPage({
            ...this.props.match.params,
            page: this.state.pageNum,
            pageSize: this.state.pageSize
        });
        if (data.isError || data.ret !== 0) {
            this.setState({
                isLoading: false,
                hasError: true
            })
        } else {
            let listData = data.data.street_snap_list;
            let pageEnd = {is_page_end: _.isEmpty(listData)};

            this.setState({
                isLoading: false,
                data: {...this.state.data, ...data.data, ...pageEnd},
                list: this.state.list.concat(listData),
                pageNum: this.state.pageNum + 1
            })
        }
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        if (_.isEmpty(this.state.data)) return null;
        return (
            <div>
                
            <div className="influencer-container deja-content-panel">
                <div className="influencer-info">
                    <div className="avatar-container"><img style={{maxWidth: '100%'}} src={this.state.data.avatar.image_url}/></div>
                    <p>{this.state.data.name}</p>
                </div>
                {/* <StreetGallery 
                    list={this.state.list} 
                    loadFunc={this.fetchData} 
                    isFetching={this.state.isLoading} 
                    cellContent={cellContent}
                    hasMore={!this.state.data.is_page_end}
                    column={300} 
                    gutter={24}
                /> */}
                <InfiniteScroll
                    pageStart={0}
                    loadMore={this.fetchData}
                    hasMore={!this.state.data.is_page_end && !this.state.isLoading}
                    threshold={800}
                >
                    {!_.isEmpty(this.state.list) && <Gallery 
                        photos={this.state.list.filter(feed => !_.isEmpty(feed)).map(feed => ({
                            src: feed.image.image_url,
                            width: feed.image.width,
                            height: feed.image.height,
                            s_id: feed.id,
                        }))} 
                        direction={"column"}
                        ImageComponent={ImageComponent}
                    />
                    }
                    {!this.state.data.is_page_end && <Loader />}
                </InfiniteScroll>
                {/* <div style={{textAlign: 'center', margin: '40px 0'}}>
                    <ActionArrow hasMore={!this.state.data.is_page_end} action={this.fetchData}/>
                </div> */}
            </div>
                <SimilarPeople influencerID={this.props.match.params.influencer_id} />
                {/* <LoaderCover loading={this.state.isLoading}/> */}
            </div>
        )
        
    }
}

const ImageComponent = ({ index, onClick, photo, margin, direction, top, left }) => {
    const imgStyle = { margin: margin };
    if (direction === 'column') {
        imgStyle.position = 'absolute';
        imgStyle.left = left;
        imgStyle.top = top;
    }

    const handleClick = event => {
        onClick(event, { photo, index });
    };

    return (
        <div className="gallery-cell-container" style={onClick ? { ...imgStyle, ...{ cursor: 'pointer' }} : imgStyle}>
            <Link to={`/streetsnap/${photo['s_id']}`}>
            <img
                width={photo.width}
                height={photo.height}
                src={photo.src}
                style={{display: 'block'}}
                // onClick={onClick ? handleClick : null}
            />
            </Link>
        </div>
    );
}

function cellContent(columnWidth, datum) {
    return (
        <div>
        <Link to={`/streetsnap/${datum['id']}`}>
          <div
            style={{
              backgroundColor: '#aaaaaa',
            //   height: datum.size * 3,
              marginBottom: '0.5rem',
              width: '100%',
              height: columnWidth*(datum.image.height / datum.image.width),
              fontSize: 20,
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}>
            <img style={{maxWidth: '100%'}} src={datum.image.image_url}/>
          </div>
          </Link>
          </div>
    )
}

export default InfluencerPage

class SimilarPeople extends Component {
    state = {
        isLoading: true,
        hasError: false,
        data: [],
        page: 0,
        pageSize: 12
    }
    fetchData = async() => {
        this.setState({
            isLoading: true,
            hasError: false
        })
        let data = await similarPeople({
            influencer_id: this.props.influencerID,
            page: this.state.page,
            pageSize: this.state.pageSize
        });
        if (data.isError || data.ret !== 0) {
            this.setState({
                isLoading: false,
                hasError: true
            })
        } else {
            if (!data.data) return;
            this.setState({
                isLoading: false,
                page: this.state.page + 1,
                data: this.state.data.concat(data.data.influencer_list),
                hasMore: !data.data.is_page_end
            })
        }
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        return (
            <div className='similar-people-container deja-content-panel'>
                {!_.isEmpty(this.state.data) && <h4>People You May Like</h4>}
                <div className='similar-people-content'>
                    {this.state.data.map((people, index) => {
                        return (
                            <div className='similar-icon-container' key={index}>
                                <Link to={`/similar_influencer/${people['influencer_id']}`}>
                                    <div className="avatar-container">
                                        <img style={{maxWidth: '100%'}} src={people.avatar_local_path} />
                                    </div>
                                    <p>{people.display_name}</p>
                                </Link>
                            </div>
                        )
                    })}
                </div>
                {!_.isEmpty(this.state.data) && !!this.state.hasMore &&
                <div style={{textAlign: 'center'}}>
                    <ActionArrow action={this.fetchData} hasMore={this.state.hasMore}/>
                </div>}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/homepage/feed/container/influencerPage.js